module.exports = __webpack_public_path__ + "media/icons/raport@2x-6f99f689.png";